import { Component, OnInit } from '@angular/core';
import { ToastService, trans } from '@kaiser-software/chassis-core';
import { WorkLogService } from '../../../work-logs/services/work-log.service';

@Component({
    selector: 'eyewatch-worked-hours-widget',
    templateUrl: './worked-hours.component.html',
    styleUrls: ['./worked-hours.component.scss']
})
export class WorkedHoursComponent implements OnInit {

    public chart: {
        data?: Array<{
            data: Array<number>,
            label: string,
        }>,
        labels?: Array<string>,
        options?: Object,
        colors?: any,
    };

    constructor(public workLogService: WorkLogService, private toastService: ToastService) {
    }

    ngOnInit() {
        const url = this.workLogService.getEndpointUrl() + '/worked-hours-widget';

        const request = this.workLogService.custom('get', url);

        request.subscribe((result: Array<any>) => {
            this.chart = {
                data: [{
                    data: result.map((item) => {
                        return item.hours;
                    }),
                    label: trans('Worked hours'),
                }],
                labels: result.map((item) => {
                    return item.date;
                }),
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                },
                colors: [{
                    backgroundColor: 'rgba(16, 207, 189, 0.5)',
                    borderColor: 'rgba(16, 207, 189, 1)',
                    borderWidth: 1,
                }],
            };
        }, () => {
            this.toastService.error();
        });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/widgets/worked-hours/worked-hours.component.ts